<app-button class="risk-dx-submit--button" title="Submit" text="Submit" (onClick)="submit()" [disabled]="disabled"></app-button>
<app-risk-dx-validation-modal [errors]="errors" ></app-risk-dx-validation-modal>
